/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosInstance } from 'axios';
import { KoddiAPIResponse } from 'types';
import { SessionData } from './Session.types';

const KODDI_SESSION_TOKEN_API = '/session/token';
class SessionAPI {
    protected axios: AxiosInstance;

    constructor(axios: AxiosInstance) {
        this.axios = axios;
    }

    /**
     * Starts the user’s session.
     */
    public login = async (
        username: string,
        password: string
    ): Promise<SessionData> => {
        const response = await this.axios.post<KoddiAPIResponse<SessionData>>(
            `v1${KODDI_SESSION_TOKEN_API}`,
            { username, password }
        );
        return response.data.result;
    };

    /**
     * Removes the user’s sessions.
     */
    public logout = async (reason?: string): Promise<string | undefined> => {
        await this.axios.post('v1/session/logout');
        this.axios.defaults.withCredentials = false;
        return reason;
    };

    /**
     * Refreshes the user session
     */
    public refresh = async (
        refreshToken: string
    ): Promise<string | undefined> => {
        const response = await this.axios.patch('v1/session/refresh', {
            refresh_token: refreshToken,
        });
        return response.data.result.token;
    };
}

export default SessionAPI;
